module.exports = __webpack_public_path__ + "static/img/you_safe_pic4.3.9d73e23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/scene/you_safe_pic4.3.jpg
// module id = BWS5
// module chunks = 0